import React from "react";

import { Link } from "../../../Link";
import { NotificationSection } from "../../../NotificationSection";
import { SUPPORT_NUMBER, SUPPORT_NUMBER_HREF } from "../../../../constants/aptihealth";

import "./styles.scss";
import { Text } from "../../../Text";

// Relates to: Profile Insurance Status

export const Pending = ({ dateChecked }) => {
  return (
    <NotificationSection className="pending">
      <Text className="bold mb-3">Please contact us.</Text>

      <Text>
        <>
          <div className="mb-3">
            We saved your new insurance info but had an issue checking your coverage.
          </div>
          <div className="mb-3">
            Contact <Link href="mailto:support@aptihealth.com">support@aptihealth.com</Link> or{" "}
            <Link href={SUPPORT_NUMBER_HREF}>{SUPPORT_NUMBER}</Link> before your next appointment to
            prevent billing issues.
          </div>
          <div>Checked: {dateChecked}</div>
        </>
      </Text>
    </NotificationSection>
  );
};

Pending.defaultProps = {
  dateChecked: "",
};
